module.exports = __webpack_public_path__ + "static/media/rating-star-empty.2a3e62c9.svg";